"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.n_ary_operation = exports.atan2 = exports.allclose = exports.isclose = exports.op_assign = exports.__make_assignment_operator = exports._assign_operation_toJS = exports.assign_operation = exports.op_binary = exports.__make_operator = exports.binary_operation = void 0;
//@ts-check
var indexes = require("./indexes");
var basic_1 = require("./basic");
var js_interface_1 = require("./js-interface");
var kwargs_1 = require("./kwargs");
var utils_js_1 = require("../utils-js");
var transform_1 = require("./transform");
var _globals_1 = require("./_globals");
var dtypes_1 = require("../dtypes");
function binary_operation(A, B, func, dtype, out) {
    if (out === void 0) { out = null; }
    if ((0, basic_1.isarray)(this))
        return func.bind(basic_1._NDArray.prototype).apply(void 0, __spreadArray([this], __read(arguments), false));
    // Find output shape and input broadcast shapes
    A = (0, basic_1.asarray)(A);
    B = (0, basic_1.asarray)(B);
    var _a = __read((0, _globals_1.broadcast_shapes)(A.shape, B.shape), 3), shape = _a[0], shapeA = _a[1], shapeB = _a[2];
    //@ts-ignore
    if (out)
        dtype = out.dtype;
    //@ts-ignore
    if (out == null)
        out = (0, basic_1.new_from)(shape, undefined, dtype);
    else if (!((0, basic_1.isarray)(out)))
        throw new Error("Out must be of type ".concat(basic_1._NDArray, ". Got ").concat(typeof out));
    // Iterate with broadcasted indices
    var flatOut = [];
    var shiftsA = (0, basic_1.shape_shifts)(shapeA);
    var shiftsB = (0, basic_1.shape_shifts)(shapeB);
    var flatA = A.flat;
    var flatB = B.flat;
    for (var i = 0; i < out.size; i++) {
        var idxA = 0, idxB = 0, idx = i;
        for (var axis = shape.length - 1; axis >= 0; axis--) {
            idxA += shiftsA[axis] * (idx % shapeA[axis]);
            idxB += shiftsB[axis] * (idx % shapeB[axis]);
            idx = Math.floor(idx / shape[axis]);
        }
        flatOut.push(func(flatA[idxA], flatB[idxB]));
    }
    ;
    out.flat = (0, dtypes_1.new_buffer)(flatOut, dtype);
    return out;
}
exports.binary_operation = binary_operation;
function __make_operator(dtype, func) {
    function operator(A, B, out) {
        if (out === void 0) { out = null; }
        return binary_operation(A, B, func, dtype, out);
    }
    ;
    //@ts-ignore
    return operator;
}
exports.__make_operator = __make_operator;
exports.op_binary = {
    "+": __make_operator(Float64Array, function (a, b) { return a + b; }),
    "-": __make_operator(Float64Array, function (a, b) { return a - b; }),
    "*": __make_operator(Float64Array, function (a, b) { return a * b; }),
    "/": __make_operator(Float64Array, function (a, b) { return a / b; }),
    "%": __make_operator(Float64Array, function (a, b) { return (a % b); }),
    "|": __make_operator(Float64Array, function (a, b) { return a | b; }),
    "&": __make_operator(Float64Array, function (a, b) { return a & b; }),
    "^": __make_operator(Float64Array, function (a, b) { return a ^ b; }),
    "<<": __make_operator(Float64Array, function (a, b) { return a << b; }),
    ">>": __make_operator(Float64Array, function (a, b) { return a >> b; }),
    "**": __make_operator(Float64Array, function (a, b) { return Math.pow(a, b); }),
    "//": __make_operator(Float64Array, function (a, b) { return Math.floor(a / b); }),
    "<": __make_operator(Uint8Array, function (a, b) { return a < b; }),
    ">": __make_operator(Uint8Array, function (a, b) { return a > b; }),
    ">=": __make_operator(Uint8Array, function (a, b) { return a >= b; }),
    "<=": __make_operator(Uint8Array, function (a, b) { return a <= b; }),
    "==": __make_operator(Uint8Array, function (a, b) { return a == b; }),
    "!=": __make_operator(Uint8Array, function (a, b) { return a != b; }),
    // Operators with custom ascii identifiers:
    "or": __make_operator(Uint8Array, function (a, b) { return a || b; }),
    "and": __make_operator(Uint8Array, function (a, b) { return a && b; }),
    "xor": __make_operator(Uint8Array, function (a, b) { return (!a) != (!b); }),
    "max": __make_operator(Float64Array, function (a, b) { return Math.max(a, b); }),
    "min": __make_operator(Float64Array, function (a, b) { return Math.min(a, b); }),
    // "approx": ,
};
exports.op_binary["↑"] = exports.op_binary["max"];
exports.op_binary["↓"] = exports.op_binary["min"];
exports.op_binary["≤"] = exports.op_binary["leq"];
exports.op_binary["≥"] = exports.op_binary["geq"];
exports.op_binary["≠"] = exports.op_binary["neq"];
function assign_operation(tgt, src, where, func) {
    if (tgt['__warnAssignment']) {
        console.warn("Warning: You are assigning on a copy that resulted from an advanced index on a source array.\nIf this is intentional, use yourArray = source.withKwArgs({copy:true}).index(...yourIndex) to make explicit your awareness of the copy operation.\nInstead, if you want to assign to the source array, use source.op('=', other) or source.op(['::3', -1, '...', [5,4]], '*=', other).\n");
        delete tgt['__warnAssignment'];
    }
    if (!((0, basic_1.isarray)(tgt))) {
        return _assign_operation_toJS(tgt, src, where, func);
    }
    if (!where) {
        binary_operation(tgt, src, func, tgt.dtype, tgt);
    }
    else {
        src = (0, basic_1.asarray)(src);
        var indices = indexes.AxesIndex.prototype.parse(tgt.shape, where).indices;
        var tmpTgt = void 0;
        if (func == null) {
            // Small optimization: unlike "+=", "*=", etc., for "=", we don't need to reed the target
            func = function (a, b) { return b; };
            tmpTgt = (0, basic_1.new_from)(indices.length, function () { return undefined; }, tgt.dtype);
        }
        else {
            tmpTgt = (0, basic_1.asarray)(indices.map(function (i) { return tgt._flat[i]; }));
        }
        binary_operation(tmpTgt, (0, basic_1.ravel)(src), func, tgt.dtype, tmpTgt);
        for (var i in indices)
            tgt._flat[indices[i]] = tmpTgt._flat[i];
    }
    return tgt;
}
exports.assign_operation = assign_operation;
;
function _assign_operation_toJS(tgtJS, src, where, func) {
    if (!Array.isArray(tgtJS))
        throw new Error("Can not assign to a non-array. Found ".concat(typeof tgtJS, ": ").concat(tgtJS));
    console.warn('Assignment to JS array is experimental and slow.');
    // Parse the whole array
    var cpy = (0, basic_1.asarray)(tgtJS);
    assign_operation(cpy, src, where, func);
    // WARNING: Creates a copy. This is terrible for arr[2, 4, 3] = 5
    var outJS = (0, js_interface_1.tolist)(cpy);
    while (tgtJS.length)
        tgtJS.pop();
    // @ts-ignore
    (0, utils_js_1.extend)(tgtJS, outJS);
    return tgtJS;
}
exports._assign_operation_toJS = _assign_operation_toJS;
// export type AssignmentOperator = { (tgt: NDArray, src: ArrayOrConstant): NDArray; (tgt: NDArray, where: Where, src: ArrayOrConstant): NDArray; }
// export type SelfAssignmentOperator = { (other: ArrayOrConstant): NDArray; (where: Where, other: ArrayOrConstant): NDArray; }
function __make_assignment_operator(func) {
    return function operator(a, values, where) {
        // console.log(`where=${JSON.stringify(where)}`)
        if (where.length === 1 && where[0] === false)
            return a;
        if (where.length === 1 && where[0] === true)
            where = [];
        return assign_operation(a, values, where, func);
    };
}
exports.__make_assignment_operator = __make_assignment_operator;
exports.op_assign = {
    "=": __make_assignment_operator(function (a, b) { return b; }),
    "+=": __make_assignment_operator(function (a, b) { return a + b; }),
    "-=": __make_assignment_operator(function (a, b) { return a - b; }),
    "*=": __make_assignment_operator(function (a, b) { return a * b; }),
    "/=": __make_assignment_operator(function (a, b) { return a / b; }),
    "%=": __make_assignment_operator(function (a, b) { return (a % b); }),
    "//=": __make_assignment_operator(function (a, b) { return Math.floor(a / b); }),
    "**=": __make_assignment_operator(function (a, b) { return Math.pow(a, b); }),
    "|=": __make_assignment_operator(function (a, b) { return a | b; }),
    "&=": __make_assignment_operator(function (a, b) { return a & b; }),
    "^=": __make_assignment_operator(function (a, b) { return a ^ b; }),
    "<<=": __make_assignment_operator(function (a, b) { return a << b; }),
    ">>=": __make_assignment_operator(function (a, b) { return a >> b; }),
    // Operators with custom ascii identifiers:
    "max=": __make_assignment_operator(function (a, b) { return Math.max(a, b); }),
    "min=": __make_assignment_operator(function (a, b) { return Math.min(a, b); }),
    "or=": __make_assignment_operator(function (a, b) { return a || b; }),
    "and=": __make_assignment_operator(function (a, b) { return a && b; }),
};
// op_assign["↑="] = op_assign["max="];
// op_assign["↓="] = op_assign["min="];
// ====================================
function isclose(A, B, rtol, atol, equal_nan) {
    var _a;
    if (rtol === void 0) { rtol = 1.e-5; }
    if (atol === void 0) { atol = 1.e-8; }
    if (equal_nan === void 0) { equal_nan = false; }
    (_a = Object.assign({ rtol: rtol, atol: atol, equal_nan: equal_nan }, this), rtol = _a.rtol, atol = _a.atol, equal_nan = _a.equal_nan);
    var func = function (a, b) {
        if (a == b)
            return true; // shortcut for equality
        if (Number.isFinite(a) && Number.isFinite(b))
            return Math.abs(a - b) <= atol + rtol * b;
        console.log('NOT FINITE', a, b);
        return (a == b) || (equal_nan && Number.isNaN(a) && Number.isNaN(b));
    };
    return binary_operation(A, B, func, Uint8Array);
}
exports.isclose = isclose;
function allclose(A, B, rtol, atol, equal_nan) {
    var _a;
    if (rtol === void 0) { rtol = 1.e-5; }
    if (atol === void 0) { atol = 1.e-8; }
    if (equal_nan === void 0) { equal_nan = false; }
    (_a = Object.assign({ rtol: rtol, atol: atol, equal_nan: equal_nan }, this), rtol = _a.rtol, atol = _a.atol, equal_nan = _a.equal_nan);
    // Equivalent to all(isclose(A, B, rtol, atol, equal_nan)), but shortcutting if false 
    var func = function (a, b) {
        if (Number.isFinite(a) && Number.isFinite(b))
            return Math.abs(a - b) <= atol + rtol * b;
        return (a == b) || (equal_nan && Number.isNaN(a) && Number.isNaN(b));
    };
    var different = new Error('');
    var wrapper = function (a, b) {
        if (!func(a, b))
            throw different;
        return 0;
    };
    try {
        binary_operation(A, B, wrapper, Float64Array);
    }
    catch (err) {
        if (err === different)
            return false;
        else
            throw err;
    }
    return true;
}
exports.allclose = allclose;
//op_binary["≈≈"] = op[MyArray.prototype.isclose,
exports.atan2 = kwargs_1.Func_y_x_out.defaultDecorator(__make_operator(Float64Array, Math.atan2));
function n_ary_operation(arrs, elem_shape, func) {
    var e_1, _a;
    // Find output shape and input broadcast shapes
    arrs = arrs.map(basic_1.asarray);
    // // Some optimization for common low-complexity cases
    // if (arrs.length == 1 && elem_shape.length == 0) {
    //   const a = arrs[0];
    //   //@ts-ignore
    //   return new_NDArray(a.flat.map(x => number_collapse(func(x))), a.shape, Number); // FIX
    // } else if (arrs.length == 1) {
    //   const a = arrs[0];
    //   const a_size = a.size;
    //   const out_elem_size = elem_shape.reduce((a, b) => a * b, 1);
    //   const outs = [];
    //   a.flat.forEach((x, i) => {
    //     //@ts-ignore
    //     const values = number_collapse(func(x));
    //     const end = (i + 1) * out_elem_size;
    //     for (let j = i * out_elem_size; j < end; j++) outs[j] = values[i];
    //   });
    //   //@ts-ignore
    //   return new_NDArray(outs, a.shape, Number); // FIX
    // }
    var rawShapes = arrs.map(function (a) { return a.shape; });
    // Broadcast shapes
    var _b = __read(_globals_1.broadcast_n_shapes.apply(void 0, __spreadArray([], __read(rawShapes), false)), 2), shapes = _b[0], shape = _b[1];
    var size = shape.reduce(function (a, b) { return a * b; }, 1);
    if (shape.length == 0) {
        return (0, basic_1.asarray)(func.apply(void 0, __spreadArray([], __read(arrs.map(function (a) { return a.flat[0]; })), false)));
    }
    var shifts = shapes.map(function (shape) { return (0, basic_1.shape_shifts)(shape); });
    function iter_n_ary() {
        var i, idx, idxs, axis, j;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < size)) return [3 /*break*/, 4];
                    idx = i;
                    idxs = arrs.map(function (_) { return 0; });
                    for (axis = shape.length - 1; axis >= 0; axis--) {
                        for (j = 0; j < arrs.length; j++) {
                            idxs[j] += shifts[j][axis] * (idx % shapes[j][axis]);
                        }
                        idx = Math.floor(idx / shape[axis]);
                    }
                    return [4 /*yield*/, [i, idxs]];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }
    // Iterate with broadcasted indices
    var flat = [];
    var funcOutIsNDArray = false;
    var _loop_1 = function (i, idxs) {
        // apply function
        var value = func.apply(void 0, __spreadArray([], __read(arrs.map(function (a, j) { return a.flat[idxs[j]]; })), false));
        if (i == 0)
            funcOutIsNDArray = (0, basic_1.isarray)(value);
        flat.push(value);
    };
    try {
        for (var _c = __values(iter_n_ary()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), i = _e[0], idxs = _e[1];
            _loop_1(i, idxs);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    ;
    var out = funcOutIsNDArray ? (0, transform_1.concatenate)(flat) : (0, basic_1.asarray)(flat);
    out = out.reshape(__spreadArray([shape], __read(out.shape.slice(1)), false));
    return out;
}
exports.n_ary_operation = n_ary_operation;
